import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyPublicSeoToDocument } from '../utils/publicSeo';
import { trackPublicPageView } from '../utils/growthAnalytics';

export default function PublicSeo() {
  const location = useLocation();

  useEffect(() => {
    applyPublicSeoToDocument(location.pathname);
    trackPublicPageView(location.pathname, document.title);
  }, [location.pathname, location.search]);

  return null;
}
